import index from "../index/es.js"
import login from "../login/es.js"
import projectList from "../projectList/es.js"
import post from "../post/es.js"
import admin from "../admin/es.js"
import outputFile from "../outputFile/es.js"
import dashboard from "../dashboard/es.js"
import explan from "../explan/es.js"

export default {
  index,
  login,
  projectList,
  post,
  admin,
  outputFile,
  dashboard,
  explan
}



// WEBPACK FOOTER //
// ./src/locale/lang/es.js